


















































import { computed, defineComponent, ref } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccCheckbox from "@/components/Atoms/OccCheckbox/index.vue";
import { createAgreement } from "@/api/index";
import { TermsType } from "@/api/types";
import { TERMS_POPUP } from "@/helpers/hooks/useTermsPopup";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { UnprocessableEntityError } from "@/api/types";
import { getErrorMessages } from "@/helpers/api-helper";

export default defineComponent({
  components: {
    OccModal,
    OccButton,
    OccHeading,
    OccCheckbox
  },
  name: "TermsPopup",
  setup(_, { root }) {
    const {
      isTermsPopupVisible,
      displayedAnnouncement,
      showNextAnnouncement,
      deleteAnnouncementFromUnagreedList,
      onCompleteTermsAgree,
      allTermsPopupAgreed
    } = useGlobalState(TERMS_POPUP);

    const checked = ref<boolean>(false);

    const onClickCheck = () => {
      checked.value = !checked.value;
    };

    const termsLabelMapping: { [type in TermsType]: string } = {
      recruitment_plan: "採用計画",
      job_posting: "求人掲載",
      scout: "スカウト",
      agent_scout: "エージェントスカウト",
      privacy_policy: "プライバシーポリシー",
      personal_information: "個人情報の取扱いについて"
    };

    const termsLabel = computed(() => {
      if (!displayedAnnouncement.value?.service_term.terms_type) return "";

      return termsLabelMapping[
        displayedAnnouncement.value?.service_term.terms_type
      ];
    });

    const termsLinkMapping: { [type in TermsType]: string } = {
      recruitment_plan: "/terms_of_use_for_plan",
      job_posting: "/terms_of_use_for_job",
      scout: "/terms_of_use_for_scout",
      agent_scout: "/terms_of_use_for_agent_scout",
      privacy_policy: "https://onecareer.co.jp/policy/",
      personal_information: "/terms_of_privacy_for_partners"
    };

    const termsLink = computed(() => {
      if (!displayedAnnouncement.value?.service_term.terms_type) return "";

      return termsLinkMapping[
        displayedAnnouncement.value?.service_term.terms_type
      ];
    });

    const onClickStart = async () => {
      const partnerUserId = root.$store.state.domains.user.partnerUser.id;

      if (!partnerUserId) return;
      if (!displayedAnnouncement.value?.service_term.id) return;

      try {
        await createAgreement({
          partner_user_id: partnerUserId,
          service_term_id: displayedAnnouncement.value.service_term.id
        });

        isTermsPopupVisible.value = false;
        deleteAnnouncementFromUnagreedList(
          displayedAnnouncement.value.service_term.id
        );

        if (allTermsPopupAgreed.value) {
          onCompleteTermsAgree();
          return;
        }

        showNextAnnouncement();
      } catch (error) {
        if (error instanceof UnprocessableEntityError) {
          const errorMessage = getErrorMessages(error);

          root.$store.commit("common/updateAlertView", {
            isVisible: true,
            title: "エラーが発生しました",
            message: errorMessage[0]
          });
        }
      }
    };

    return {
      checked,
      onClickCheck,
      createAgreement,
      termsLabel,
      termsLink,
      onClickStart,
      displayedAnnouncement
    };
  }
});
